// const config = {
//   APIBaseUrl: 'http://fudapi.urts55.uni-trier.de/api/schwitters/',
//   // APIBaseUrl: 'http://chost22.zim.uni-wuppertal.de/fudapi/api/schwitters/',
//   // APIBaseUrl: 'http://localhost:3010/api/schwitters/',
//   accesToken: 'Bearer [[Token]]'
// }
import config from '../../config/config.json'

const queryPromiseCache = {};

export const queryPromise = function (params) {
  const url = config.APIBaseUrl + params;
  if (queryPromiseCache[url]) {
    // console.log("query from cache", url);
    return queryPromiseCache[url];
  }
  const promise = new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      beforeSend: xhr => {
        xhr.setRequestHeader("Authorization", config.accesToken);
      },
      method: "GET"
    })
      .done(res => {
        resolve(res);
      })
      .fail(err => {
        reject(err);
      });
  });
  queryPromiseCache[url] = promise;
  return queryPromiseCache[url];
};



export const postQuery = function (params, data) {
  const url = config.APIBaseUrl + params;
  const promise = new Promise((resolve, reject) => {
    $.ajax({
      url: url,
      beforeSend: xhr => {
        xhr.setRequestHeader("Authorization", config.accesToken);
      },
      format: 'JSON',
      data: data,
      method: 'POST'
    })
      .done(res => {
        resolve(res);
      })
      .fail(err => {
        reject(err);
      });
  });
  queryPromiseCache[url] = promise;
  return queryPromiseCache[url];
};





// WEBPACK FOOTER //
// ./src/api/index.js